export { collectData } from "./collectData";
